<template>
  <div class="tool-bar" v-bind:class="[active===''?minwrap:maxwrap]">
    <div class="option" v-bind:class="active">
      <div class="option-item folder" v-on:click="setOptionActive('folder')">
        <i v-if="active==='folder'" class="fa fa-folder-open" aria-hidden="true"></i>
        <i v-else class="fa fa-folder" aria-hidden="true"></i>
      </div>
    </div>
    <!-- <div v-if="active==='folder'" class="catalog">
        <div class="edit">
            <div class="add">
                <div class="add-file"><img src="../assets/afile.png"></div>
                <div class="add-folder"><img src="../assets/af.png"></div>
            </div>
            <div class="more-choose"><i class="fa fa-plus" aria-hidden="true"></i></div>
        </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'ToolBar',
  data () {
    return {
      active: 'folder',
      minwrap: 'min-wrap',
      maxwrap: 'max-wrap'
    }
  },
  methods: {
    setOptionActive (item) {
      if (this.active === item) {
        this.active = ''
      } else {
        this.active = item
      }
    }
  }
}
</script>

<style scoped>
  .option,.catalog{
    display: inline-block;
    height: 100%;
  }
  .tool-bar{
    display: inline-block;
    float: left;
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    -webkit-flex-direction: row;
    flex-wrap: nowrap;
    min-width: 70px;
    user-select: none;
  }
  .option{
    min-width: 50px;
    width: 50px;
    background-color: #323B4A;
  }
  .option-item{
      margin-top: 48px;
      width: 50px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      cursor:pointer;
      color: white;
      font-size: 16px;
  }
  .option.folder .folder{
      background-color: #0e1926;
  }
  .catalog{
    width: 100px;
    background-color: rgb(228,240,255);
    flex: 1;
  }
  .min-wrap{
      min-width: 50px;
  }
  .max-wrap{
      min-width: 70px;
  }
  .edit{
      margin-top: 48px;
      width: 100%;
      height: 50px;
  }
  .edit>div{
      display: inline-block;
      height: 50px;
      text-align: center;
  }
  .add{
      margin-left: 10px;
  }
  .add>div{
      width: 30px;
      display: inline-block;
      height: 50px;
      cursor: pointer;
  }
  .add>.add-file>img{
      height: 20px;
      vertical-align: top;
      margin: auto;
      margin-top: 15px;
  }
  .add>.add-folder>img{
      height: 18px;
      vertical-align: top;
      margin: auto;
      margin-top: 16px;
  }

  .more-choose{
      float: right;
      width: 40px;
      cursor: pointer;
  }
  .more-choose>i{
       font-size: 12px;
       line-height: 50px;
   }
  .more-choose:hover{
      color: #207fc0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ToolBar.vue